import React from "react"

import Layout from "../components/layout/layout"
import CareerComponent from "../components/careers/Careers"
import SEO from "../components/seo"

const Careers = () => (
  <Layout withBrand slidePosition={0}>
    <SEO
      title="Wersel Careers"
      description="Do you want to work with us? Build a career working with Wersel. Apply for job openings, by emailing your updated resume or CV to careers@datinfi.com"
      keywords="wersel careers, wersel, wersel brand analytics, wersel data hub"
      url="www.wersel.io/careers"
    />
    <CareerComponent />
  </Layout>
)

export default Careers
